import React from 'react';
import './IndexCard.css'; // This will be for styling

interface IndexCardProps {
    identifier: string;
    batchIdentifier?: string;
    title?: string;
}

const IndexCard: React.FC<IndexCardProps> = ({ identifier, batchIdentifier, title }) => {
    return (
        <>
            <div className="index-card">
            <p style={{fontSize: '10pt', textAlign: 'center'}}>
            {title ?? 'Survey Card - NE G&P'}
            </p>
                <h1 style={{fontSize: '3em', textAlign: 'center'}}>{identifier}</h1>
                {/* {!!batchIdentifier && (<p style={{textAlign: 'right', marginRight: '1em', marginTop: '18em'}}>{batchIdentifier}</p>)} */}
            </div>
        </>
    );
};

export default IndexCard;
